import { createContext, useContext } from "react";
import { ApplicationProgress } from "api/applications";

export type ApplicantChatHandler = (person: {
  applicantId: number;
  name: string;
}) => void;

export type ApplicantProgressContextValue = {
  progressByApplicationId: Map<number, ApplicationProgress>;
  isProgressError?: boolean;
  onChatClick?: (applicationId: number) => ApplicantChatHandler;
};

export const ApplicantProgressContext =
  createContext<ApplicantProgressContextValue>({
    progressByApplicationId: new Map()
  });

export const useApplicantProgressContext = () =>
  useContext(ApplicantProgressContext);
